/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ValidateGroupingRulesRequest {
    getFixupPrototypeFunction() { return ValidateGroupingRulesRequest.fixupPrototype; }

    static newInstance(model: Partial<ValidateGroupingRulesRequest>): ValidateGroupingRulesRequest {
        let obj = Object.assign(new ValidateGroupingRulesRequest(), model);
        ValidateGroupingRulesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ValidateGroupingRulesRequest>): ValidateGroupingRulesRequest {
        if (!model) return null;
        return ValidateGroupingRulesRequest.newInstance(<ValidateGroupingRulesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ValidateGroupingRulesRequest) {
        if (!obj) return;

        models.ValidateGroupingRulesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ValidateGroupingRulesRequest): boolean {
        Object.setPrototypeOf(obj, ValidateGroupingRulesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rules) {
            for (let val of this.rules) {
                models.DimensionGroupingRule.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Dimension Grouping Rules to validate
     */
    rules: Array<models.DimensionGroupingRule>;

}
